import { Component, Input } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BlogExcerpt } from '@app/@shared/models/market-analysis/market-analysis';
import { AnalysisFilter } from '@app/@shared/models/reverse-engineering/analysis.models';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SearchService } from '@shared/services/search/search.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractSubscriptionContentsComponent, SubscriptionContentContextModel } from '../../abstract/abstract-subscription-contents/abstract-subscription-contents.component';
import { NavigationService } from '@app/@shared/services/navigation/navigation.service';
import { EntitlementService } from '@app/@shared/services/entitlement/entitlement.service';
import { FilterHelper } from '@app/@shared/utils/filter-helper';
import { TelemetryService } from '@app/@shared/services/telemetry-service';
import { BlogContent } from '@app/@shared/models/search/cti-search.model';

@UntilDestroy()
@Component({
    selector: 'app-blog-search',
    templateUrl: './blog-search.component.html',
    styleUrls: ['./blog-search.component.scss'],
    standalone: false
})
export class BlogSearchComponent extends AbstractSubscriptionContentsComponent {
  @Input() getContext: () => Observable<SubscriptionContentContextModel>;
  blogs: Array<BlogContent>;
  blogCount: number;

  constructor(
    route: ActivatedRoute,
    router: Router,
    navigationService: NavigationService,
    private searchService: SearchService,
    private entitlementService: EntitlementService,
    telemetryService: TelemetryService
  ) {
    super(route, router, navigationService, telemetryService);
  }

  @Input() onClickBlog = (blog: BlogContent): void => {
    if (!blog.entitled) {
      const modalTitle = `TechStream: ${blog.subscriptionName}: ${blog.name}`;
      this.entitlementService.openRequestAccessConfirmDialog(modalTitle);
    } else {
      const fragment = blog.subscriptionName? 'name=' + encodeURIComponent(blog.subscriptionName): '';
      this.router.navigate(blog.contentUrl, { fragment });
    }
  };

  protected requestContent(queryParams: ParamMap): Observable<AnalysisFilter[]> {
    const isTag = !!this.tagFilters;
    const filters = {
      ...FilterHelper.parseFiltersFromParams(queryParams),
      ...this.tagFilters,
      subscriptionId: isTag? []: this.subscriptionIds,
      channelId:  isTag? []: this.channelIds,
      includeSectionedBlogs: `${isTag}`
    };

    return this.searchService.getBlogs(this.searchTerm, filters, this.paginationOptions).pipe(
      map((result) => {
        this.blogs = result.contentList as BlogContent[];
        this.blogCount = result.count;
        return result.filters;
      }),
    );
  }
}
